import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';

const outlinedButtonStyle = (main: string, hoverBg: string) => ({
    borderColor: main,
    color: main,
    '&:hover': {
        borderColor: main,
        backgroundColor: hoverBg,
    },
});

export const buttonOverrides: Components<Theme>['MuiButton'] = {
    styleOverrides: {
        root: {
            textTransform: 'none',
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none',
            },
            '&:active': {
                boxShadow: 'none',
            },
            '&.MuiButton-contained': {
                boxShadow: 'none',
                '&:hover': {
                    boxShadow: 'none',
                },
                '&:active': {
                    boxShadow: 'none',
                },
            },
            '&.MuiButton-contained:disabled': {
                backgroundColor: COLORS.grey[50],
            },
            '&:disabled': {
                color: COLORS.grey[200],
            },
        },
        colorInherit: {
            color: COLORS.black[900],
            borderColor: COLORS.white[900],
            '&.MuiButton-contained': {
                backgroundColor: COLORS.grey[100],
                '&:hover': {
                    backgroundColor: COLORS.grey[50],
                    color: COLORS.grey[300],
                },
            },
            '&:active': {
                backgroundColor: COLORS.grey[400],
                color: COLORS.black[900],
            },
            '&.MuiButton-outlined': {
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    color: COLORS.black[900],
                },
            },
        },
    },
    variants: [
        {
            props: {variant: 'outlined', color: 'primary'},
            style: outlinedButtonStyle(COLORS.primary.main, COLORS.primary[100]),
        },
        {
            props: {variant: 'outlined', color: 'secondary'},
            style: outlinedButtonStyle(COLORS.secondary.main, COLORS.secondary[100]),
        },
        {
            props: {variant: 'outlined', color: 'success'},
            style: outlinedButtonStyle(COLORS.success.main, COLORS.success[100]),
        },
        {
            props: {variant: 'outlined', color: 'error'},
            style: outlinedButtonStyle(COLORS.error.main, COLORS.error[100]),
        },
        {
            props: {variant: 'outlined', color: 'warning'},
            style: outlinedButtonStyle(COLORS.warning.main, COLORS.warning[100]),
        },
        {
            props: {variant: 'outlined', color: 'info'},
            style: outlinedButtonStyle(COLORS.info.main, COLORS.mithraBlue[100]),
        },
    ],
};
